export function getAmount(params: { safety?: number; current?: number }) {
  const { safety = 0, current = 0 } = params;

  return current - safety;
}
